<template>
  <section class="main-slider">
    <slick
      ref="slick"
      :options="slickOptions"
      @afterChange="handleAfterChange"
      v-if="sliders.length > 0"
    >
      <home-slider-item
        class="main-slider__slide"
        v-for="slide in sliders"
        :key="slide.name"
        :data="slide"
      />
    </slick>
    <div class="main-slider__arrows">
      <button class="main-slider__arrows--left" @click="prev()">
        <arrowsvg class="icon" />
      </button>
      <button class="main-slider__arrows--right" @click="next()">
        <arrowsvg class="icon" />
      </button>
    </div>

    <div
      class="main-slider__progress"
      v-show="this.progressVisible"
      :style="{ width: this.currentProgress + '%' }"
    ></div>
  </section>
</template>

<script>
import Slick from "vue-slick";
import ArrowSVG from "../../../assets/arrow.svg";
import HomeSliderItem from "./home-slider-item.component";

export default {
  components: {
    Slick,
    arrowsvg: ArrowSVG,
    "home-slider-item": HomeSliderItem,
  },
  name: "home-slider",

  props: {
    sliders: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentProgress: 1,
      reRender: true,
      timeInterval: 0,
      progressVisible: true,
      currentSlider: 0,
      slickOptions: {
        slidesToShow: 1,
        arrows: false,
        infinite: true,
        speed: 900,
        cssEase: "cubic-bezier(.15,.22,.6,.9)",
      },
    };
  },
  mounted() {
    clearInterval(this.timeInterval);
    this.currentProgress = 0;

    this.startSliderProgressBar();

    this.$hub.$on("setLanguage", () => {
      if (this.$refs.slick) {
        this.reRender = false;
        this.reRender = true;

        this.$nextTick(() => {
          this.reRender = true;
        });
      }
    });
  },

  destroyed() {
    clearInterval(this.timeInterval);
    this.currentProgress = 0;
  },

  watch: {
    sliders() {
      this.$nextTick(() => {
        if (this.$refs.slick) {
          this.playCurrentVideoSlider($(this.$refs.slick.$el));
        }
      });
    },
  },

  methods: {
    startSliderProgressBar() {
      this.progressVisible = true;
      this.timeInterval = setInterval(this.scene, 250);
    },

    scene() {
      if (this.currentProgress >= 100) {
        this.next();
        this.progressVisible = false;
        setTimeout(this.restartProgress, 450);
        return;
      }

      this.currentProgress += 2;
    },

    next() {
      if (this.$refs.slick) {
        this.$refs.slick.next();
      }
    },

    prev() {
      if (this.$refs.slick) {
        this.$refs.slick.prev();
      }
    },

    restartProgress() {
      clearInterval(this.timeInterval);

      this.currentProgress = 0;
      this.startSliderProgressBar();
    },

    handleAfterChange(event, slider, index) {
      if (index !== this.currentSlider) {
        this.currentSlider = index;

        for (let i = 0; i < document.getElementsByTagName("video").length; i += 1) {
          document.getElementsByTagName("video")[i].pause();
          document.getElementsByTagName("video")[i].currentTime = 0;
        }

        this.playCurrentVideoSlider(event);
      }

      this.restartProgress();
    },

    playCurrentVideoSlider(slider) {
      for (
        let i = 0;
        i <
        $(slider.target || slider)
          .find(".slick-current")
          .find("video").length;
        i += 1
      ) {
        const video = $(slider.target || slider)
          .find(".slick-current")
          .find("video");

        video[i].play();
      }
    },
  },
};
</script>

<style lang="scss">
@import "./styles/home-slider";
</style>
